module.exports = __webpack_public_path__ + "media/images/brands/g-suite-abb6a281e214631a463caeefcfd6e04c.png";